import { FaLocationArrow } from "react-icons/fa";
import { BiPlus, BiMinus } from "react-icons/bi";

const MapControls = ({ map }) => {
  const handleZoomIn = () => {
    map.setZoom(map.zoom + 1);
  };

  const handleZoomOut = () => {
    map.setZoom(map.zoom - 1);
  };

  const goToCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          map.setCenter(pos);
          map.panTo(pos);
          map.setZoom(20);
        },
        () => alert("Give a permission to the browser to access your location.")
      );
    }
  };
  return (
    <div className="flex items-center absolute top-0 left-0 z-10 m-4">
      <div className="current-location-control m-1">
        <button
          onClick={goToCurrentLocation}
          className=" h-9 w-9 bg-white rounded flex justify-center items-center transition-all duration-200 hover:bg-primary-700 hover:text-white shadow"
        >
          <FaLocationArrow />
        </button>
      </div>
      <div className="zoom-in-control m-1">
        <button
          onClick={handleZoomIn}
          className=" h-9 w-9 bg-white rounded flex justify-center items-center transition-all duration-200 hover:bg-primary-700 hover:text-white shadow"
        >
          <BiPlus />
        </button>
      </div>
      <div className="zoom-out-control m-1">
        <button
          onClick={handleZoomOut}
          className=" h-9 w-9 bg-white rounded flex justify-center items-center transition-all duration-200 hover:bg-primary-700 hover:text-white shadow"
        >
          <BiMinus />
        </button>
      </div>
    </div>
  );
};

export default MapControls;
